import PropTypes from 'prop-types';

import Asset from '../Asset';
import {
  Asset as AssetType,
} from '../header/header.types';
import { assetPropTypes } from '../../../common/asset.propTypes';

interface EyebrowImageProps {
  asset: AssetType;
}

const EyebrowImage = ({ asset }: EyebrowImageProps) => (
  <Asset
    asset={asset}
  />
);

EyebrowImage.propTypes = {
  asset: PropTypes.shape(assetPropTypes).isRequired,
};

export default EyebrowImage;
